<template>
  <div
    class="wrapper h-100 d-flex flex-column align-center justify-center pb-4"
    :class="{boxed}"
  >
    <div v-if="user.loggedIn" class="topbar text-right w-100 py-2 px-3">
      <UserInfo />
    </div>

    <div class="content">
      <div class="px-4 mb-8">
        <slot name="prepend">
          <router-link to="/">
            <v-img contain height="45" src="/img/logo.png" />
          </router-link>
        </slot>
      </div>

      <v-card
        color="white"
        :elevation="boxed ? undefined : 0"
        :class="{
          'py-6': boxed,
          'px-4': boxed
        }"
      >
        <slot></slot>
      </v-card>
      <slot name="append">
        <small
          class="links d-flex justify-space-between mt-1"
          :class="{'px-4': !boxed}"
        >
          <slot name="links"></slot>
        </small>
      </slot>
    </div>
  </div>
</template>

<script>
  import UserInfo from './UserInfo';


  export default {
    name: 'PageWrapper',

    components: {
      UserInfo
    },

    computed: {
      boxed() {
        return this.$vuetify.breakpoint.smAndUp;
      },

      user() {
        return this.$store.getters['session/getUser'];
      }
    }
  };
</script>

<style lang="scss" scoped>
  .wrapper {
    background-color: #fff;
    padding-top: 52px; // Topbar height

    &.boxed {
      background-color: transparent;
    }
  }

  .topbar {
    position: absolute;
    top: 0;
    left: 0;
  }

  .content {
    width: 100%;
    max-width: 540px;
  }

  .links a {
    text-decoration: none;
  }
</style>
